// extracted by mini-css-extract-plugin
module.exports = {"blog":"SimilarBlogs_blog__3HCEc","single_similar_blog":"SimilarBlogs_single_similar_blog__9bv49","similar_blog_grid":"SimilarBlogs_similar_blog_grid__ABSSs"};